import { useState } from 'react';
import UseContext from 'hooks/useContext';
import BillingMemberView from './BillingMemberView';

/** « Modifier le contact de facturation » for a member (JBWEB-1285). */
const ModalEditBillingMember = () => {
  const { language, modalData } = UseContext();
  // Read once: « modalData » belongs to whichever modal opens next.
  const [{ idCompany, member }] = useState(() => ({
    idCompany: modalData?.idCompany,
    member: modalData?.member ?? {},
  }));

  return (
    <BillingMemberView
      idCompany={idCompany}
      member={member}
      title={language.getValue('companyBillingContacts.member.editTitle', '')}
      isEdit
    />
  );
};

export default ModalEditBillingMember;
